import axios from 'axios';
import Log from '../util/Log';
import BoutiqueHours from '../util/BoutiqueHours';

const voucherApiUrl = window.VoucherConfig.voucherApiUrl.length
    ? window.VoucherConfig.voucherApiUrl
    : 'http://dev.fabe.ie/api';

const Api = {
    getProfessionals: function(locationId, callback) {
        const query = locationId
            ? '/wp-json/wp/v2/person?staff=' + locationId + '&per_page=100&_embed'
            : '/wp-json/wp/v2/person?per_page=100&_embed';

        axios.get(window.WPURLS.siteurl + query)
             .then(response => {
                let professionals = response.data.map(function(item) {
                    return {
                        title: item.title.rendered,
                        subtitle: item.subtitle,
                        image: item.image,
                        id: item.id,
                        locations: item.locations,
                    }
                })

                professionals.unshift({id: 0, empty: true, title: window.trans.any_professional, locations: []});

                callback(professionals)
            }).catch(error => {
                Log.exception(error, 'get-professionals')
            });
    },

    // unused ?
    postError: function(data, callback) {
        axios({
            method: 'POST',
            url: window.WPURLS.siteurl + '/wp-json/5th/v1/log-wp-error',
            data: { error_data: data },
            config: { headers: {'Content-Type': 'multipart/form-data' }},
        }).then(response => {
            //handle success
            callback(true, response);
        }).catch(response => {
            //handle error
            callback(false, response)
        });
    },

    // unused ?
    // postVoucher: function(data, callback) {
    //     if (window.VoucherConfig.voucherApiUrl.length) {
    //         axios({
    //             method: 'POST',
    //             url: 'https://fifthavenuecork.ie/api/voucher',
    //             data: data,
    //             config: { headers: {'Content-Type': 'multipart/form-data' }},
    //         }).then(response => {
    //             callback(true, response.data);
    //         }).catch(error => {
    //             callback(false);
    //             Log.exception(error, 'purchase-voucher', [{ request: data, response: error }]);
    //         });
    //     } else {
    //         callback(true, {
    //             'result': 'success',
    //             'download_url': 'https://fifthavenuecork.ie/download/qeet',
    //         })
    //     }
    // },

    createStripeSession: function(data, callback) {
        axios({
            method: 'POST',
            url: `${voucherApiUrl}/stripe-session`,
            data: data,
            config: { headers: {'Content-Type': 'multipart/form-data' }},
        }).then(response => {
            callback(true, response.data);
        }).catch(error => {
            callback(false);
            Log.exception(error, 'purchase-voucher', [{ request: data, response: error }]);
        });
    },

    getPurchasedVoucher: function(sessionId, callback) {
        axios({
            method: 'POST',
            url: `${voucherApiUrl}/stripe-pdf`,
            data: { id: sessionId },
            config: { headers: {'Content-Type': 'multipart/form-data' }},
        }).then(response => {
            callback(true, response.data);
        }).catch(error => {
            callback(false);
            Log.exception(error, 'purchase-voucher', [{ request: { id: sessionId }, response: error }]);
        });
    },

    getBoutiques: function(callback) {
        axios.get(window.WPURLS.siteurl + '/wp-json/wp/v2/staff?per_page=100&_embed')
            .then(response => {
                let mainBoutiqueEmail = '';

                let boutiques = response.data.map(function(item) {
                    if (item.main_location) {
                        mainBoutiqueEmail = item.order_email;
                    }

                    return {
                        name: item.name,
                        address: item.address,
                        image: item.images[0].image,
                        id: item.id,
                        orderEmail: item.order_email,
                        hours: BoutiqueHours.getBoutiqueHours(item.working_hours),
                        mainLocation: item.main_location,
                    };
                });

                boutiques.unshift({
                    id: 0,
                    empty: true,
                    name: window.trans.any_boutique,
                    orderEmail: mainBoutiqueEmail,
                    hours: BoutiqueHours.getMinMaxBoutiqueHours(boutiques),
                });

                callback(boutiques)
            }).catch(error => {
                Log.exception(error, 'get-boutiques');
            })
    },

    getUpsells: function(data, callback) {
        axios.get(window.WPURLS.siteurl + '/wp-json/5th/v1/upsells?exclude=' + data.join(','))
            .then(callback)
            .catch((error => {
                Log.exception(error, 'upsells');
            }))
    },

    makeAppointment: function(data, callback) {
        axios({
            method: 'POST',
            url: window.WPURLS.siteurl + '/wp-json/5th/v1/make-appointment',
            data: data,
            config: { headers: {'Content-Type': 'multipart/form-data' }},
        }).then(response => {
            callback(true, response);
        }).catch(error => {
            Log.exception(error, 'make-appointment', [{ request: data, response: error }]);
            callback(false, error);
        });
    },

    getVouchers: function(callback) {
        axios.get(`${voucherApiUrl}/vouchers/1`)
            .then(response => {
                callback(true, response.data)
            }).catch(error => {
                Log.exception(error, 'get-vouchers');
            });
    },
};

export default Api;



// WEBPACK FOOTER //
// ./scripts/util/Api.js